var _path, _g, _path2, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a983",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4,
    width: 14,
    height: 10
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 9.632a3.484 3.484 0 0 1-3.472 3.493H3.68a3.484 3.484 0 0 1-3.487-3.48V9.64s.005-3.056.01-4.592c0-.289.332-.45.558-.27A749.818 749.818 0 0 1 5.37 8.48a2.77 2.77 0 0 0 3.493-.008c.036-.024 2.904-2.325 4.57-3.648a.345.345 0 0 1 .559.27C14 6.618 14 9.631 14 9.631",
    fill: "#130F26"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a983)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b983)",
    d: "M-1.188 4.841H15.38v9.319H-1.188z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "c983",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 8
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.639 2.545a3.476 3.476 0 0 0-3.07-1.846H3.68c-1.294 0-2.47.719-3.068 1.846a.596.596 0 0 0 .152.744l5.126 4.1c.359.29.794.434 1.229.434h.014c.434 0 .87-.144 1.228-.434l5.126-4.1a.596.596 0 0 0 .153-.744",
    fill: "#130F26"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c983)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#d983)",
    d: "M-1.186-.337h16.568v9.319H-1.186z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b983",
    x1: -1.188,
    y1: 4.841,
    x2: -1.188,
    y2: 14.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d983",
    x1: -1.186,
    y1: -0.337,
    x2: -1.186,
    y2: 8.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPerson);
export default __webpack_public_path__ + "static/media/ic_person.2ad3e0b3.svg";
export { ForwardRef as ReactComponent };